Vivense = {};
Vivense.init = {};


Vivense.validateError = function(errorMsg){

    var loginForm = $(".failed-login-wrapper");
    loginForm.text(errorMsg);
    loginForm.addClass("failed-login");


};

Vivense.displayError = function (error) {

    var msg;

    if (error) {
        if ($.isArray(error)) {
            msg = error[0];
        } else {
            msg = error;
        }
    } else {
        msg = 'Bir hata oluştu.';
    }

    swal({
        'title': '',
        'text': msg,
        'type': 'error',
        'confirmButtonText': 'Tamam'
    });
};

jQuery(document).ready(function () {




    var $ = jQuery;

    $(".main-list").mouseenter(function() {


        var lazyImages = $( this ).find( "img.lazy-header" );



        lazyImages.lazyload({
            effect: "fadeIn",
            placeholder: "/assets/images/placeholder_img/header_no_image.jpg"
        });
    });


    $(".kvkk-modal-content").mCustomScrollbar({
        theme:"dark",
        scrollInertia:300
    });


    $(".close-cookie-popup").on("click", function () {
        $(".cookie-warning-wrapper").remove();
        Vivense.cookie.set("vivense_policy", "1", (24 * 30 * 12 * 3));
    });

    if(!Vivense.cookie.exist("vivense_policy")){
        $(".cookie-warning-wrapper").addClass("show-cookie-popup");
    }

    $(document).on("click", "#customuserpopup", function () {
        $(".login-form-slide-box").removeClass("slide-register");
        $(".user-action-wrapper").removeClass("popup-active");
        $(".popup-action-title").removeClass("active-tab");
        $(".register-switch").addClass("active-tab");
        $(".basket-register-text").hide();
        Vivense.loginPopup.open("header");
    });
    $(document).on("click", "#custom-user-login", function () {
        $(".login-form-slide-box").addClass("slide-register");
        $(".user-action-wrapper").removeClass("popup-active");
        $(".popup-action-title").removeClass("active-tab");
        $(".login-switch").addClass("active-tab");
        $(".basket-register-text").hide();
        Vivense.loginPopup.open("header");
    });
    $(document).on("click", ".customer-group .my-favorites-container", function () {
        $(".popup-action-title").removeClass("active-tab");
        $(".register-title").addClass("active-tab");
        Vivense.loginPopup.openFavoritesPopup("header_f");
    });

    $(".register-login").on("mouseenter", function () {
        $(".user-action-wrapper").addClass("popup-active");
    }).on("mouseleave", function () {
        $(".user-action-wrapper").removeClass("popup-active");
    });

    $(".my-cart").on("mouseenter", function () {
        $(".user-cart-area").addClass("popup-active");
    }).on("mouseleave", function () {
        $(".user-cart-area").removeClass("popup-active");
    });
    // $(".support-center-container").on("mouseenter", function () {
    //     $(".support-center-wrapper").addClass("popup-active");
    // }).on("mouseleave", function () {
    //     $(".support-center-wrapper").removeClass("popup-active");
    // });


    $("#header_favori_column").on("click",function () {

        if(window.userId !=0) {

            window.location="/favorilerim.html?ref=menu_image"

        }else{
            $(".category_menu_inner_wrapper").addClass("hidden_inner");

            setTimeout(function(){
                $(".category_menu_inner_wrapper").removeClass("hidden_inner");
            }, 1000);

            $(".my-favorites-container").trigger("click");
        }



    });

    $(".showroom-location-container").hover(function () {
            $(".showroom-location-container .shwrm-desc").addClass("shw-area");
        },
        function () {
            $(".showroom-location-container .shwrm-desc").removeClass("shw-area");
        });


    $(".campaign-menu-container").hover(function () {
            $(".cmp-area").addClass("shw-area");
        },
        function () {
            $(".cmp-area").removeClass("shw-area");
        });

    // Show Coupon Modal on Registration
    if (parseInt(window.userId) !== 0 && Vivense.cookie.get('showCouponModal') == 1){
        var couponPopup = $("#couponPopup");
        var couponCode = 'H' + parseInt(window.userId).toString(16).toUpperCase();
        couponPopup.find('#copiedText').val(couponCode);
        couponPopup.find('#copyToClipboard').click(function(){
            var aux = document.createElement("input");
            aux.setAttribute("value", couponCode);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);
            $(this).text('Kod kopyalandı');
        });

        couponPopup.modal();
        Vivense.cookie.delete('showCouponModal');
    }

    function scrollToTop() {
        var element = $('body');
        var offset = element.offset();
        var offsetTop = offset.top;
        $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
    }

    var jqueryWin = $(window);
    var wrapper = $('.scroll-top-wrapper');

    if (wrapper.length == 0) {
        return;
    }

    var showing = false;
    var cutoff = 500;

    function checkScroll() {
        var scrollTop = jqueryWin.scrollTop();

        if (scrollTop > cutoff && !showing) {
            wrapper.addClass('show');
            showing = true;

        } else if (scrollTop <= cutoff && showing) {
            wrapper.removeClass('show');
            showing = false;
        }

    }

    setInterval(checkScroll, 1500);

    wrapper.on('click', scrollToTop);

    var body = $("body");

    $("#search-suggestion").on("focus", function () {

        $("body").append("<div id=\"mm-blocker\" class=\"mm-slideout\"></div>");

        $(".modal-backdrop").remove();
        body.append('<div class="modal-backdrop in"></div>');
        $("form#header-search-form").addClass("focus-search");

    }).blur(function () {
        $(".modal-backdrop").remove();
        $("form#header-search-form").removeClass("focus-search");
        $("body").remove("<div id=\"mm-blocker\" class=\"mm-slideout\"></div>");
    })

});

